// extracted by mini-css-extract-plugin
export default {"block":"News_block__Xb7gi","back":"News_back__RVHfQ"};